import { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { useDetails } from "../../../../../context/details"
import { UrlInterface } from "../../../../../types";
import { AppNames, fetchAskADoctorParticipations, fetchDoveCommunitiesParticipations, fetchDoveHubParticipations, fetchParticipations } from "./utils";
import { Data as AskADcotorParticipation } from "../../../../modules/Participation/ParticipationCardDoctor/ParticipationCardDoctor.interface";
import { Data as ParticipationInterface } from "../../../../modules/Participation/ParticipationRow/ParticipationRow.interface";
import { useParams } from "react-router-dom";

export const useParticipations = () => {
  const { id } = useParams();
  const { detailsDispatch, data } = useDetails();
  const { participationsUrl } = data || {};
  const [askADoctorData, setAskADoctorData] = useState<{
    data: AskADcotorParticipation | null,
    url: UrlInterface | null,
    isLoading: boolean
  }>({
    data: null,
    url: null,
    isLoading: true
  });

  const [doveHubData, setDoveHubData] = useState<{
    data: {
      results: ParticipationInterface[] | [],
      count: number
    }
    url: UrlInterface | null,
    isLoading: boolean
  }>({
    data: {
      results: [],
      count: 0
    },
    url: null,
    isLoading: true
  });

  const [doveCommunitiesData, setDoveCommunitiesData]= useState<{
    data: {
      results: ParticipationInterface[] | [],
      count: number
    }
    url: UrlInterface | null,
    isLoading: boolean
  }>({
    data: {
      results: [],
      count: 0
    },
    url: null,
    isLoading: true
  });

  const handleTabChange = ({ id, name }: {
    id: number,
    name?: string
  }) => {
    detailsDispatch({
      type: "setActiveTab",
      data: {
        id,
        name: name || ""
      }
    })
  }

  const showAllParticipations = ({ name, url, appName }: {
    url: UrlInterface | null,
    appName: AppNames,
    name: string,
  }) => {
    if (url) {
      detailsDispatch({
        type: "setParticipationsDetailsUrl",
        data: {
          url,
          appType: appName
        }
      })
    }
    handleTabChange({ id: 3, name });
  }

  const dataLoaded = useRef(false);
  
  useEffect(() => {
    if (!dataLoaded.current) {
      dataLoaded.current = true;
      fetchParticipations(participationsUrl).then((res) => {
        const allParticipationsUrl = res;
        if (allParticipationsUrl) {
          if (!askADoctorData.data) {
            fetchAskADoctorParticipations(allParticipationsUrl[AppNames.aad]).then((res) => {
              setAskADoctorData({
                data: res,
                url: allParticipationsUrl[AppNames.aad],
                isLoading: false
              })
            })
          }
          if (doveHubData.data.count === 0) {
            fetchDoveHubParticipations(allParticipationsUrl[AppNames.dovehub]).then((res) => {
              setDoveHubData({
                data: res,
                url: allParticipationsUrl[AppNames.dovehub],
                isLoading: false
              })
            })
          }
          if (doveCommunitiesData.data.count === 0) {
            fetchDoveCommunitiesParticipations(allParticipationsUrl[AppNames.community]).then((res) => {
              setDoveCommunitiesData({
                data: res,
                url: allParticipationsUrl[AppNames.community],
                isLoading: false
              })
            })
          }
        }
      })
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return {
    handleTabChange,
    askADoctorData,
    doveHubData,
    doveCommunitiesData,
    showAllParticipations
  }
}
